import { combineReducers } from "redux";
import feedReducer from "./feedReducer";
import tutorFeedReducer from "./tutorFeedReducer";
import emReducer from "./emReducer";

// console.log = function() {

export default combineReducers({
  feedRed: feedReducer,
  feedTutorRed: tutorFeedReducer,
  emReducer: emReducer,
});
